// returns the category path based on the categories array
export function getCategoryPath(categories) {
  if (categories.includes('nyc-elopement-locations')) {
    return 'elopement/nyc-elopement-locations';
  }
  if (categories.includes('engagement-locations')) {
    return 'wedding/engagement-locations';
  }
  return 'wedding-venues';
}
